export function displayIndexFromInternal(internal: number, count: number): number {
  if (count <= 1) return 0
  if (internal <= 0) return count - 1
  if (internal >= count + 1) return 0
  return internal - 1
}

export function clampLoopInternal(internal: number, count: number): number {
  if (count <= 1) return 0
  return Math.max(0, Math.min(count + 1, internal))
}

export function clampDisplayIndex(display: number, count: number): number {
  if (count <= 1) return 0
  return Math.max(0, Math.min(count - 1, display))
}

export function initialInternalIndex(count: number): number {
  return count > 1 ? 1 : 0
}

export function internalIndexFromDisplay(display: number, count: number, loop: boolean): number {
  if (!loop || count <= 1) return display
  return display + 1
}
